module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-home-property-pin-2d3dfaa13bbc494c1b9834ee0f26ddbc.svg";